import { ProfileForm } from '@agentic-flow-studio/shared/components/profile/ProfileForm';

export default function Profile() {
  return <ProfileForm />;
}
